import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  Avatar,
  Select,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormLabel,
  Divider,
  Input,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { DynamicFormActions } from "../../redux/actions/DynamicFormAction";
import { history } from "../helpers/History";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import EsignatureConfirmation from "./EsignatureConfirmation";
import Logo from "../../img/logo.jpg";
import moment from "moment";
import html2PDF from "jspdf-html2canvas";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  square: {
    borderRadius: 0,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
    background: "transparent",
    width: 150,
    height: 80,
  },
});

class DynamicForm extends React.Component {
  constructor(props) {
    super(props);
  }

  exportAsPdf() {
    let page = document.getElementById("pdfContent");
    html2PDF(page, {
      jsPDF: {
        format: "a4",
      },
      imageType: "image/jpeg",
      output: this.props.documentInfo.displayName + "" + ".pdf",
    });
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Document View</title>
        </Helmet>
        <Container component="main" maxWidth={false}>
          <CssBaseline />
          <Paper className={classes.paper}>
            <Box
              display="flex"
              justifyContent="flex-end"
              m={1}
              p={1}
              bgcolor="background.paper"
            >
              <Box p={1}>
                <Button
                  variant="contained"
                  color="default"
                  onClick={() => {
                    this.exportAsPdf();
                  }}
                >
                  Download
                </Button>
              </Box>
            </Box>

            <Box
              className={classes.form}
              noValidate
              name="form"
              id="pdfContent"
            >
              <Box p={2} 
              borderColor="grey.500"
              border={1}>
              <Box display="flex" p={1}>
                <Box p={1} flexGrow={1}>
                  <Avatar
                    variant="square"
                    src={Logo}
                    className={classes.square}
                  ></Avatar>
                </Box>
                <Box p={1}>
                  <Typography variant="body2">
                    Confirmation Time :{" "}
                    {moment(
                      new Date(this.props.documentInfo.confirmationDate)
                    ).format("DD/MM/YYYY hh:mm a")}
                  </Typography>
                  <Typography variant="body2">
                    Date : {moment(new Date()).format("DD/MM/YYYY hh:mm a")}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography color="primary" align="center" variant="h3">
                  {this.props.documentInfo.displayName}
                </Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography
                  color="default"
                  variant="h5"
                  className={classes.typography}
                >
                  {this.props.documentInfo.formDescription}
                </Typography>
              </Box>
              <Grid container spacing={1}>
                {this.props.documentInfo.fieldValues &&
                  this.props.documentInfo.fieldValues.length > 0 &&
                  this.props.documentInfo.fieldValues.map((value, index) => {
                    return (
                      <Grid item xs={12} md={12} key={index}>
                        {value && value.type == "Date" && (
                          <TextField
                            fullWidth
                            margin="normal"
                            id={value.label}
                            name={value.label}
                            label={value.label}
                            value={value.value}
                            type="date"
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                            }}
                            disabled
                          />
                        )}
                        {value && value.type == "DateTime" && (
                          <TextField
                            fullWidth
                            margin="normal"
                            id={value.label}
                            name={value.label}
                            label={value.label}
                            type="datetime-local"
                            className={classes.textField}
                            value={value.value}
                            InputLabelProps={{
                              readOnly: true,
                            }}
                            disabled
                          />
                        )}
                        {value && value.type == "Text" && (
                          <TextField
                            fullWidth
                            label={value.label}
                            margin="normal"
                            autoComplete="off"
                            value={value.value}
                            InputLabelProps={{
                              readOnly: true,
                            }}
                            disabled
                          />
                        )}
                        {value && value.type == "CheckBox" && (
                          <FormControlLabel
                            margin="normal"
                            control={
                              <Checkbox
                                checked={value.value}
                                name={value.label}
                                InputLabelProps={{
                                  readOnly: true,
                                }}
                                disabled
                              />
                            }
                            label={value.label}
                          />
                        )}
                        {value &&
                          (value.type == "Select" ||
                            value.type == "MultiSelect") && (
                            <TextField
                              fullWidth
                              label={value.label}
                              margin="normal"
                              autoComplete="off"
                              value={
                                (value.value && value.value.indexOf("~")) > 0
                                  ? value.value.replaceAll("~", " , ")
                                  : value.value
                              }
                              disabled
                              InputLabelProps={{
                                readOnly: true,
                              }}
                            />
                          )}

                        {value && value.type == "Radio" && (
                          <FormControl
                            margin="normal"
                            component="fieldset"
                            className={classes.resetOptions}
                            fullWidth
                          >
                            <FormLabel component="legend">
                              {value.label}
                            </FormLabel>

                            <RadioGroup
                              row
                              aria-label={value.name}
                              name={value.name}
                              defaultValue="top"
                              value={value.value}
                              disabled
                            >
                              <FormControlLabel
                                value={value.value}
                                label="Start"
                                control={<Radio />}
                                label={value.label}
                              />
                            </RadioGroup>
                          </FormControl>
                        )}
                      </Grid>
                    );
                  })}
              </Grid>
              {this.props.documentInfo.esignatureCaptured == "true" && (
                <Typography
                  color="secnodary"
                  variant="h5"
                  className={classes.typography}
                >
                  {"I, "}
                  {this.props.documentInfo.firstName}
                  {"    "}
                  {this.props.documentInfo.lastName}
                  {
                    ", agree that I have read all of the areas of the document and have provided all accurate information as represented."
                  }
                </Typography>
              )}
            </Box>
            </Box>
            <Divider variant="middle" className={classes.divider} />
            <div className={classes.buttons}>
              <Button
                variant="contained"
                color="default"
                className={classes.button}
                onClick={() => {
                  history.goBack();
                }}
              >
                Cancel
              </Button>
            </div>
          </Paper>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DynamicForm));
